declare namespace $ {

	type $mol_link__title_shm_showcase_info_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_shm_showcase_info_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_info['source_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_shm_showcase_info_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_text__text_shm_showcase_info_4 = $mol_type_enforce<
		ReturnType< $shm_showcase_info['description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__uri_base_shm_showcase_info_5 = $mol_type_enforce<
		ReturnType< $shm_showcase_info['readme_uri'] >
		,
		ReturnType< $mol_text['uri_base'] >
	>
	export class $shm_showcase_info extends $mol_page {
		source_uri( ): string
		Source( ): $mol_link
		description( ): string
		readme_uri( ): string
		Description( ): $mol_text
		entry_id( ): string
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=info.view.tree.d.ts.map